$(window).on('load', function () {
    
        
      var subscribeAjaxUrl = '//manage.kmail-lists.com/ajax/subscriptions/subscribe';
      var subscribeUrl = '//manage.kmail-lists.com/subscriptions/subscribe';
//       document.body.insertAdjacentHTML( 'afterbegin', '<div class="overlay-bg"></div> <div class="overlay-content popup1"> <div class="popup-content"> <div class="imagebg"> <img src="https://cdn.shopify.com/s/files/1/1626/4849/files/popup.png?v=1648843766" /> </div> <div class="subscribe-form-bg"> <div class="subscribe-text"> <p class="close-btn">x</p> </div> <div class="subscribe-form"> <div class="klaviyo-form-Xq26L7"></div> </div> </div> </div> </div>');
        
    // function to show our popups
    function showPopup(whichpopup){
        var docHeight = $(document).height(); //grab the height of the page
        var scrollTop = $(window).scrollTop(); //grab the px value from the top of the page to where you're scrolling
        $('.overlay-bg').show().css({'height' : docHeight}); //display your popup background and set height to the page height
        $('.popup'+whichpopup).show(); //.css({'top': scrollTop+100+'px'})show the appropriate popup and set the content 100px from the window top
        $('.popup'+whichpopup).addClass('active');
    }

//       KlaviyoSubscribe.attachToForms('#email_signup_popup', {
//         hide_form_on_success: true,
//         extra_properties: {
//           $source: '$embed',
//           $method_type: "Klaviyo Form",
//           $method_id: 'embed',
//           $consent_version: 'Embed default text'
//         }
//       });
    // function to close our popups
    function closePopup(){
      $('.overlay-bg, .overlay-content').hide(); //hide the overlay
      $('.overlay-content-overflow-hide').removeClass('active');
    }

  // timer if we want to show a popup after a few seconds.
  //get rid of this if you don't want a popup to show up automatically
  setTimeout(function() {
    if(localStorage.getItem('popState') != 'shown'){
      // Show popup1 after 5 seconds
      // showPopup(1);

      // localStorage.setItem('popState','shown')
    }
  }, 4000);


    // show popup when you click on the link
    $('.show-popup').click(function(event){
        event.preventDefault(); // disable normal link function so that it doesn't refresh the page
        var selectedPopup = $(this).data('showpopup'); //get the corresponding popup to show
        
        showPopup(selectedPopup); //we'll pass in the popup number to our showPopup() function to show which popup we want
    });
    $('a.sizingchart').click(function(event){
      event.preventDefault();
      showPopup(2);
    });
  
    // hide popup when user clicks on close button or if user clicks anywhere outside the container
    $('.close-btn, .overlay-bg').click(function(){
        closePopup();
    });
    
    // hide the popup when user presses the esc key
    $(document).keyup(function(e) {
        if (e.keyCode == 27) { // if user presses esc key
            closePopup();
        }
    }); 
  
  $('footer .newsletter-form__field-wrapper').click(function() {
      var newWindowWidth = $(window).width();
      window._klOnsite = window._klOnsite || [];
      if (newWindowWidth < 768) {
          // window._klOnsite.push(['openForm', 'XNZGim']);
        //window._klOnsite.push(['openForm', 'T8i3d5']);
        window._klOnsite.push(['openForm', 'Sd9Znj']);
      } else {
        // window._klOnsite.push(['openForm', 'UE843v']);
        // window._klOnsite.push(['openForm', 'T6Zh3R']);
        window._klOnsite.push(['openForm', 'VN8grg']);
      }
  });

    
});
